import React, { useContext } from "react"
import { Modal } from "./NewModal"
import { css, useTheme } from "@emotion/react"
import { Flex } from "rebass"
import { ListItem } from "./checkout/ListItem"
import { BodyTextRegular, BodyTextSemibold } from "./typography/text"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { translationKeys } from "../util/translationKeys"
import { useTranslation } from "react-i18next"
import StoreContext from "../context/store-context"
import { CollectionMethodIdentifiers } from "../util/collection-method-identifiers"

const modalStyle = css`
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

type Props = {
  onClick?: () => void
}

export const InitialCollectionMethodModal = ({ onClick }: Props) => {
  const theme = useTheme()
  const {
    initialCollectionMethodChosen,
    setInitialCollectionMethodChosen,
    setCollectionMethod,
  } = useContext(StoreContext)
  const { t } = useTranslation()
  const iconWrapper = css`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    background-color: ${theme.colors.ctaLight};
  `

  return (
    <Modal
      title={`${t(translationKeys.popupDeliverymethodTitle)}`}
      subtitle={`${t(translationKeys.popUpDeliverymethodSubtitle)}`}
      isVisible={!initialCollectionMethodChosen}
      onClose={() => {
        setCollectionMethod(CollectionMethodIdentifiers.pickup)
        setInitialCollectionMethodChosen(CollectionMethodIdentifiers.pickup)
        if (onClick) {
          onClick()
        }
      }}
    >
      <Flex css={modalStyle}>
        <ListItem
          Title={
            <BodyTextSemibold color={theme.colors.primary}>
              {t(translationKeys.venuedetailsDeliveryOptionsPickup)}
            </BodyTextSemibold>
          }
          type="choose"
          onClick={() => {
            setCollectionMethod(CollectionMethodIdentifiers.pickup)
            setInitialCollectionMethodChosen(CollectionMethodIdentifiers.pickup)
            if (onClick) {
              onClick()
            }
          }}
          Left={
            <Flex css={iconWrapper}>
              <BodyTextSemibold color={theme.colors.ctaMain}>
                <FontAwesomeIcon icon={solid("person-walking")} />
              </BodyTextSemibold>
            </Flex>
          }
          Right={
            <Flex className="choose-button">
              <BodyTextRegular color={theme.colors.ctaMain}>
                {t(translationKeys.webChoose)}
              </BodyTextRegular>
            </Flex>
          }
        ></ListItem>
        <ListItem
          Title={
            <BodyTextSemibold color={theme.colors.primary}>
              {t(translationKeys.venuedetailsDeliveryOptionsDelivery)}
            </BodyTextSemibold>
          }
          type="choose"
          onClick={() => {
            setCollectionMethod(CollectionMethodIdentifiers.courier)
            setInitialCollectionMethodChosen(
              CollectionMethodIdentifiers.courier
            )
            if (onClick) {
              onClick()
            }
          }}
          Left={
            <Flex css={iconWrapper}>
              <BodyTextSemibold color={theme.colors.ctaMain}>
                <FontAwesomeIcon icon={solid("biking")} />
              </BodyTextSemibold>
            </Flex>
          }
          Right={
            <Flex className="choose-button">
              <BodyTextRegular color={theme.colors.ctaMain}>
                {t(translationKeys.webChoose)}
              </BodyTextRegular>
            </Flex>
          }
        ></ListItem>
      </Flex>
    </Modal>
  )
}
